import { render, staticRenderFns } from "./SwiperCard.vue?vue&type=template&id=c21ed804&"
import script from "./SwiperCard.vue?vue&type=script&lang=js&"
export * from "./SwiperCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports